
import { Container, Row } from "reactstrap";
import { Col } from "react-bootstrap";
import { Breadcrumbs } from '../../AbstractElements';
import SettingHome from "./SettingHome";
import React, { Fragment } from 'react'

export default function SettingList() {
    return (
        <Fragment>
            <Breadcrumbs mainTitle="Setting" parent="Home" title="Setting" />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                        <SettingHome/>    
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
